import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { SearchInput } from '~/eds/src/components/SearchInput/SearchInput';
import { useDebouncedState } from '~/eds/src/hooks/useDebouncedState';
import { Nullable } from '~/types/Nullable';

type Props = {
  onSearch: (value: Nullable<string>) => void;
};

export const UsersSearchBar = ({ onSearch }: Props) => {
  const intl = useIntl();
  const [debouncedState, search, setSearch] =
    useDebouncedState<Nullable<string>>('');

  useEffect(() => {
    onSearch(debouncedState);
  }, [debouncedState]);

  return (
    <SearchInput
      width="100%"
      name="search"
      value={search}
      onChange={(value) => {
        setSearch(value);
      }}
      placeholder={intl.formatMessage({
        id: 'UsersSearchBar.searchPlaceholder',
        defaultMessage: 'Search users',
        description: 'Placeholder text for user search input field',
      })}
    />
  );
};
